/** Aviso al intentar salir de Carga de documentos con una ingesta en curso. */

export const INGEST_UPLOAD_IN_PROGRESS_LEAVE_TITLE = 'Carga en curso';

export const INGEST_UPLOAD_IN_PROGRESS_LEAVE_MESSAGE =
  'Hay una ingesta en progreso. Si sales ahora, la carga se cancela y deberás volver a subir el lote.\n\n' +
  'Qué hacer: espera a que termine «Subir lote» (el botón dejará de mostrar el indicador de carga) y luego usa Volver.';

/** true = se puede salir; false = bloquear navegación/Volver. */
export function canLeaveIngestUploadScreen(uploading: boolean): boolean {
  return !uploading;
}

/**
 * Resultado de los diálogos «Documento duplicado».
 * Si el usuario canceló alguno, no se continúa la carga.
 */
export function resolveIngestDuplicateConfirmDecision(
  answers: readonly boolean[],
  pendingCount: number,
): { proceed: boolean; confirmNewVersion: boolean } {
  const allConfirmed =
    pendingCount > 0 &&
    answers.length === pendingCount &&
    answers.every((answer) => answer === true);
  return {
    proceed: allConfirmed,
    confirmNewVersion: allConfirmed,
  };
}
